
<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
            <div class="p-4 flex justify-between w-full">
            <div><h3>Lista de estudiantes</h3> </div>
            <div><vs-button @click="popupActive = true">Agregar</vs-button></div>
            </div>
            <div class="p-4 w-full">
                <span>
                  <vs-list v-bind:key="index" v-for="(student, index)  in listStudents">
                    <div class="flex">
                        <div class="w-5/6">
                            <vs-list-header icon="supervisor_account" v-bind:title="'' + student.nombres + ' ' + student.apellidos">
                            </vs-list-header>
                            <div style="font-weight: 600; font-size: 15px;">
                                <!-- <vs-chip color="primary" >
                                <vs-avatar icon="notifications" />
                            Mención: <label  style="color:white!important;" v-text="student.curso"/>
                            </vs-chip> -->
                                <p>
                                    <b>Curso: </b>
                                        <span>{{ student.curso }} </span>
                                    <br>
                                    <template v-if="student.mencion != ''">
                                        <b>Mención: </b>
                                            <span> {{ student.mencion }} </span>
                                        <br>
                                    </template>
                                    <b> CI: </b>
                                        <span> {{ student.numero_identificacion }} </span> 
                                </p>
                            </div>
                        </div>
                        <div class="md:flex mt-8">
                            <div>
                                <vs-button class="btn-students md:mr-1 mb-1" color="primary" @click="comprarUtiles(student)" title="Comprar útiles">
                                    <span class="material-symbols-outlined centrar">backpack</span>
                                 </vs-button>
                            </div>
                            <div>
                                <vs-button class="btn-students" color="danger" @click="(selectStudent = student), (popupDelete = !popupDelete)" title="Eliminar estudiante" ><i class="material-icons">delete</i></vs-button>
                            </div>
                        </div>


                        <!-- <div class="w-1/6 p-8"> -->
                            <!-- <vs-button data-toggle="tooltip" data-placement="bottom" title="Eliminar estudiante" data-original-title="Eliminar estudiante" radius @click="(selectStudent = student), (popupDelete = !popupDelete)" type="filled" color="danger" icon="delete" class="delete"></vs-button> -->
                            <!-- <vs-button @click="popupActive = true" class="m-1">Comprar útiles</vs-button> -->
                            <!-- <vs-button color="danger" @click="popupActive = true" class="m-1">Eliminar estudiante</vs-button> -->
                    
                        <!-- </div> -->
                    </div>
                    <!-- <vs-row vs-justify="flex-end" >
                        <vs-button data-toggle="tooltip" data-placement="bottom" title="Eliminar estudiante" data-original-title="Eliminar estudiante" radius @click="(selectStudent = student),(popupDelete = !popupDelete) " type="filled" color="danger" icon="delete" class="delete"></vs-button>
                    </vs-row> -->
                     
                        <!-- <vs-list-item icon="check" title="Número Identificación:" v-bind:subtitle="student.numero_identificacion"></vs-list-item> -->
                  </vs-list>    
                </span>
            </div>
            <!-- <div slot="footer" align="right">
                <vs-button @click="popupActive=true">Agregar</vs-button> -->
                <!--vs-button @click="login()" type="gradient" color="danger" icon="favorite"></vs-button>
                <vs-button color="rgb(230,230,230)" color-text="rgb(50,50,50) insertUpdate(student),$event " icon="settings"></vs-button-->

            <!-- </div> -->
            <vs-popup class="holamundo" title="Eliminar Estudiante" :active.sync="popupDelete">
                <p>¿Está seguro de eliminar al  estudiante <b> {{(selectStudent == null ) ? null : selectStudent.nombre_completos   }}</b>?
                    <br>
                </p>
                <div class="flex flex-wrap justify-between mb-3">
                    <vs-button  color="success" @click="insertUpdate('U')">Aceptar</vs-button>
                    <vs-button  color="danger"  @click="(popupDelete = !popupDelete),(selectStudent = null)">Cancelar</vs-button>
                </div>
            </vs-popup>
            <vs-popup class="holamundo" title="Formulario de creación de estudiantes" :active.sync="popupActive">
                   <div class="flex flex-wrap justify-between my-5">
                        <vs-input
                            data-vv-validate-on="blur"
                            type="text"
                            name="contrasenia"
                            icon-no-border
                            v-model="numero_identificacion_estudiante"
                            icon="icon icon-user"
                            icon-pack="feather"
                            label-placeholder="Cédula de estudiante*"
                            class="w-full mt-6" />
                   </div>      
                    <div class="flex flex-wrap justify-between mb-3">
                        <vs-button  color="primary" @click="insertUpdate('I')">Agregar</vs-button>
                        <vs-button  color="danger" @click="(popupActive = !popupActive)">Cancelar</vs-button>
                    </div>
            </vs-popup>
            <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
                   <div class="flex flex-wrap justify-between my-5">
                      {{ (mensaje) == null ? null : mensaje }}
                   </div>      
                    <div class="flex flex-wrap justify-center mb-3">
                        <vs-button  color="primary" @click="popupMensaje = !popupMensaje">Aceptar</vs-button>
                    </div>
            </vs-popup>                      
        </vs-card>
      </vs-col>
    </vs-row>

</template>

<script>
export default {
    data() {
        return {
            popupActive: false,
            numero_identificacion_estudiante:null,
            popupDelete: false,
            popupMensaje:false,
            mensaje:null,
            selectStudent:[],
            listStudents:[],
        }
    },
    methods: {
        validatorOnline(){
            if(!this.$store.state.AppActiveUser.status)
            this.$router.push('/');
            else
                this.loadGeneralStudens();
        },
        clearForm(){
            this.numero_identificacion_estudiante = '';
        },
        loadGeneralStudens(){
            var _this = this;
            this.listStudents = [];
                var playLoad = {
                    "id_usuario": this.$store.state.AppActiveUser.id_usuario,
                    "cod_persona":this.$store.state.AppActiveUser.cod_persona,
                    "estado":"A"

                }
            this.$vs.loading();
            this.$store.dispatch('student/loadGeneral', playLoad)
            .then((response) => { this.$vs.loading.close() 
                    _this.listStudents  =     response.data.data;
            })
            .catch(error => {
                this.$vs.loading.close()
                this.popupMensaje = !this.popupMensaje;
                this.mensaje      = error.message;
            })
        },
        insertUpdate($evento){
            this.popupDelete = false;
            this.popupActive = false;
            
            this.$vs.loading();
            this.selectStudent.id_usuario = this.$store.state.AppActiveUser.id_usuario;

            this.selectStudent.evento     = $evento;
            if($evento == 'I') this.selectStudent.numero_identificacion = this.numero_identificacion_estudiante
            var _this = this;
            
            this.$store.dispatch('student/insertUpdate', this.selectStudent)
            .then((response) => { this.$vs.loading.close() 
                    this.clearForm();
                    this.loadGeneralStudens();
                    this.popupMensaje = !this.popupMensaje;
                    this.mensaje      = response.data.mensaje;
            })
            .catch(error => {
                this.$vs.loading.close();
                this.clearForm();
                this.loadGeneralStudens();
                this.popupMensaje = !this.popupMensaje;
                this.mensaje      = 'Alumno no matriculado.';
            });
        },

        comprarUtiles(estudiante) {
            localStorage.removeItem('student');
            localStorage.setItem('student', JSON.stringify(estudiante));
            location.href = `${window.location.origin}/#/list/complete`;
        }
    },
    created(){
        this.validatorOnline();
    }
}
</script>

<style>
@media screen  {
    
}

.centrar{
    margin: 0 auto !important;
}

.btn-students{
    height: 50% !important;
    padding: 0rem 2rem !important;
}


.delete{
     width: 25px !important;
     height: 25px !important;
     padding: 5px !important;
     float:right !important;
     margin-top: 12px !important;
}
</style>